export default "__VITE_PUBLIC_ASSET__6e74681f__"